import { useSelector } from "react-redux";

import { useSearchLinksActions } from "store/SearchLinksSlice";

const useSearchLinks = () => {
  const { getSearchLinks } = useSearchLinksActions();

  const { searchLinks } = useSelector((state) => state.SearchLinksSlice);

  return { searchLinks, getSearchLinks };
};

export default useSearchLinks;
